// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "ErrorLayout__body__X1xuU";
export const bold = "700";
export const buttonWrapper = "ErrorLayout__buttonWrapper__YUQ10";
export const buttons = "ErrorLayout__buttons__t1sR7";
export const circles = "ErrorLayout__circles__pYAJz";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headerButtonWrapper = "ErrorLayout__headerButtonWrapper__H3fd5";
export const medium = "500";
export const memberCircle = "ErrorLayout__memberCircle__7K2QF";
export const othersCircle = "ErrorLayout__othersCircle__ZoS7f";
export const peersCircle = "ErrorLayout__peersCircle__s8Qhp";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const superTitle = "ErrorLayout__superTitle__wWnko";
export const text = "ErrorLayout__text__4XA68 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const title = "ErrorLayout__title__cgTpO font-faces__serifLight__iGPdI font-faces__serif__XseuP";